import React, { useState, useEffect } from 'react';
import './App.css';

function App() {
  const [phoneNumbers, setPhoneNumbers] = useState([]);
  const [capableNumbers, setCapableNumbers] = useState([]);
  const [testers, setTesters] = useState([]);
  const [responseMessage, setResponseMessage] = useState('');

  useEffect(() => {
    // Fetch phone numbers from the backend
    const fetchPhoneNumbers = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/phone-numbers`);
        const data = await response.json();
        setPhoneNumbers(data);
      } catch (error) {
        console.error('Error fetching phone numbers:', error);
      }
    };

    fetchPhoneNumbers();
  }, []);

  const getCapabilities = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/get-capabilities`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
      setCapableNumbers(data.capableNumbers);
      setResponseMessage(`Found ${data.capableNumbers.length} capable numbers and ${data.nonCapableNumbers.length} non-capable numbers.`);
      
      // Update phoneNumbers state to include capability information
      setPhoneNumbers(prevPhoneNumbers => 
        prevPhoneNumbers.map(phone => ({
          ...phone,
          isCapable: data.capableNumbers.some(capablePhone => capablePhone.number === phone.number)
        }))
      );
    } catch (error) {
      console.error('Error fetching capabilities:', error);
      setResponseMessage('Failed to fetch capabilities. Please try again.');
    }
  };

  const addTester = async (phoneNumber) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/add-tester`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ phoneNumber }),
      });
      const data = await response.json();
      if (response.ok) {
        setResponseMessage(data.message);
        setTesters([...testers, phoneNumber]);
      } else {
        setResponseMessage(data.error);
      }
    } catch (error) {
      console.error('Error adding tester:', error);
      setResponseMessage('Failed to add tester. Please try again.');
    }
  };

  return (
    <div className="App">
      <header className="App-header">
        <h1>RBM Manager</h1>
        <button onClick={getCapabilities} className="fetch-button">
          Get Capabilities
        </button>
        <div className="phone-list">
          {phoneNumbers.map(phone => (
            <div key={phone.number} className="phone-item">
              <span>{phone.label} ({phone.number})</span>
              {phone.isCapable ? (
                <button 
                  onClick={() => addTester(phone.number)} 
                  className="add-button"
                  disabled={testers.includes(phone.number)}
                >
                  {testers.includes(phone.number) ? 'Already a Tester' : 'Add as Tester'}
                </button>
              ) : (
                <span className="not-capable">Not RBM Capable</span>
              )}
            </div>
          ))}
        </div>
        {responseMessage && (
          <p className="response-message">Response: {responseMessage}</p>
        )}
      </header>
    </div>
  );
}

export default App;
